import axiosInstance from './axiosInstance';

// DB-backed Clapsley settings (recipients, toggles, default group JID).
// Secrets (ApiKey, BaseUrl) live in server appsettings — NOT returned by these endpoints.
export const getClapsleySettings = () =>
    axiosInstance.get('/Admin/GetClapsleySettings');

export const saveClapsleySettings = (cfg) =>
    axiosInstance.put('/Admin/SaveClapsleySettings', cfg);

// Manual triggers — Super Admin only on the backend
export const sendLeaderboardNow = () =>
    axiosInstance.post('/Admin/SendLeaderboardNow');

// recipients is an optional array of JIDs / phones; empty means "use default GroupJid"
export const sendClapsleyTestMessage = (text, recipients = []) =>
    axiosInstance.post('/Admin/SendTestMessage', { text, recipients });
